import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  NucleusOrgUnit,
  NucleusOrgUnitNotifierContract,
  NucleusOrgUnitServiceContract,
  NucleusOrgUnitType
} from '@nucleus/org-unit-ui';
import { OrgUnitService as OrgUnitApi, OrgUnitPayload } from '@nucleus/org-unit-ui';
import { BaseComponent } from '@nucleus/ui-base';

/**
 * NUC-NNN (mirror of GOLD-89 / NUC-267): thin adapters wiring tasksense's
 * OrgUnit OpenAPI client + notification stack into the @nucleus/org-unit-ui
 * contracts. The lib never imports tasksense code; everything reaches it via
 * DI. NUC-294: access is gated by the shared CAPABILITY_CHECKER (wired
 * app-wide to PermissionsService) — the lib resolves OrgUnitCaps codes itself;
 * the old NUCLEUS_ORG_UNIT_PERMISSIONS seam was removed in
 * @nucleus/org-unit-ui 0.0.13.
 */

@Injectable({ providedIn: 'root' })
export class TasksenseOrgUnitServiceAdapter implements NucleusOrgUnitServiceContract {
  private api: OrgUnitApi = inject(OrgUnitApi);

  list(unitType: NucleusOrgUnitType): Observable<NucleusOrgUnit[]> {
    return this.api.list(unitType as any) as unknown as Observable<NucleusOrgUnit[]>;
  }
  create(payload: NucleusOrgUnit): Observable<NucleusOrgUnit> {
    return this.api.create(payload as unknown as OrgUnitPayload) as unknown as Observable<NucleusOrgUnit>;
  }
  rename(id: string, payload: NucleusOrgUnit): Observable<NucleusOrgUnit> {
    return this.api.rename(id, payload as unknown as OrgUnitPayload) as unknown as Observable<NucleusOrgUnit>;
  }
  delete(id: string): Observable<void> {
    return this.api._delete(id) as unknown as Observable<void>;
  }
}

/** Bridges the lib's notifier contract into BaseComponent's snackbar +
 *  ConfirmationDialog plumbing. */
@Injectable()
export class TasksenseOrgUnitNotifierAdapter
  extends BaseComponent
  implements NucleusOrgUnitNotifierContract {

  success(message: string): void { super.showSuccess(message); }
  error(message: string):   void { super.showError(message); }
  override confirm(title: string, message: string): Promise<boolean> {
    return super.confirm(title, message);
  }
}
